import { render } from "./NavbarLogin.vue?vue&type=template&id=56edd7a2"
import script from "./NavbarLogin.vue?vue&type=script&lang=js"
export * from "./NavbarLogin.vue?vue&type=script&lang=js"

import "./NavbarLogin.vue?vue&type=style&index=0&id=56edd7a2&lang=css"
script.render = render

export default script